import { render } from "./AppMain.vue?vue&type=template&id=22d3c6be&scoped=true"
import script from "./AppMain.vue?vue&type=script&lang=ts"
export * from "./AppMain.vue?vue&type=script&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=22d3c6be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-22d3c6be"

export default script